import { createWidget } from '@typeform/embed';

function initializeForms() {
  document.querySelectorAll('[data-shortcode-form]').forEach((element) => {
    const formId = element.getAttribute('data-form-id');
    createWidget(formId, {
      container: element,
      disableAutoFocus: true,
      height: 500,
      hideHeaders: true,
      hideFooter: true,
      inlineOnMobile: true,
      opacity: 0,
    });
  });
}

initializeForms();
